import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { isAdminEmail } from "../utils/adminAuth";

interface AdminRouteProps {
  children: React.ReactNode;
}

// Se usa siempre DENTRO de PrivateRoute: para cuando el flujo llega
// hasta acá ya sabemos que hay un usuario logueado (PrivateRoute ya
// resolvió el estado de "loading" de la sesión). Acá solo se valida
// que el email sea el del admin; si no lo es, se manda de vuelta al
// dashboard en lugar de mostrar el panel.
const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user } = useAuth();

  if (!isAdminEmail(user?.email)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
